import moment from 'moment'

import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

export default {
  name: 'FormDateEditable',

  mixins: [textFieldMixin],

  props: {
    required: Boolean,
    value: String
  },

  data: () => ({
    date: null,
    modal: false
  }),

  created () {
    // expect value from java LocalDate, e.g. 2013-05-30
    this.date = this.value

    // update parent with current value in UTC format
    this.$emit('input', this.date)

    // init validation
    this.validateInit()
  },

  methods: {
    handleDatePickerInput (item, event) {
      // reset validation
      this.validateReset()
      // update parent with current value in UTC format
      this.$emit('input', item)
      this.modal = false
      this.$refs.dialog.save(item)
    },

    handleTextChange (item) {
      this.$emit('input', item)
    },

    handleOnFocus (item) {
      // init validation
      this.validateInit()
    },

    handlePickerClick (item, event) {
      if (this.validateInput(item) !== true) {
        this.date = moment().startOf('day').format('YYYY-MM-DD')
      }
      this.modal = true
    },

    validateInput (inputText) {
      if (!inputText) {
        return true
      }
      const datePattern = /\d{4}-\d{2}-\d{2}/
      return (datePattern.test(inputText) && moment(inputText).isValid()) || this.$t('message.validationDate')
    },

    validateInit () {
      this.validationRules = [
        value => { return this.validateInput(value) }
      ]
    },

    validateReset () {
      this.validationRules = []
    }
  }
}
